import { createAction, createReducer } from "@reduxjs/toolkit";

export const setEdit = createAction('setEdit')
export const removeEdit = createAction('removeEdit')
export const resetCellEdit = createAction('resetCellEdit')


const initialState = {
    edit: [],
};

export const cellEdit = createReducer(initialState, {
    [setEdit]: (state, action) => {
        return{
            edit: [...state.edit, action.payload],   
        }
    },
    [removeEdit]: (state, action) => {
        return {
            edit: state.edit.filter(i => i !== action.payload),
        } 
    },
    [resetCellEdit]: () => {
        return {
            edit: [],
        }
    }
});

